import React from "react"
import styled from "styled-components"

const Section = styled.section`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: auto;
    padding: 80px 16px 46px;
    @media screen and (min-width: 768px) {
        padding-top: 110px;
        padding-bottom: 110px;
    }
    @media screen and (min-width: 1024px) {
        padding-top: 140px;
        padding-bottom: 140px;
    }
`

export default ({ title, subtitle, theme, children }) => (
    <Section className={`bg-${theme}-lightest text-${theme}-text`}>
        <div className="container container--grid">
            <div className="container__row">
                <div className="laptop:w-4-5 mx-auto text-center">
                    <h1 className="Section__text pb-xxs">{title}</h1>
                    {subtitle && (
                        <h2 className="Section__text subtitle pt-xs">
                            {subtitle}
                        </h2>
                    )}
                    {children}
                </div>
            </div>
        </div>
    </Section>
)
